import { gql } from '@apollo/client'

export const Copropriete = {
  fragments: {
    etat: gql`
      fragment Etat on Copropriete {
        etat {
          couleur
          nombreDeLotsVendus
          total
        }
      }
    `,
    gestionnaire: gql`
      fragment Gestionnaire on Copropriete {
        gestionnaire {
          id
          nom
          prenom
        }
        gestionnaireSedentaire {
          id
          nom
          prenom
        }
        comptable {
          id
          nom
          prenom
        }
      }
    `,
  },
}
